/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});


/**
 * Extend Kivi JS with a better accordion handling
 */
var showDefault = document.querySelectorAll(".show-by-default");
showDefault.forEach(function(item) {
  item.classList.add("not-hidden");
  var select = item.dataset.target;
  document.getElementById(select).classList.add("not-hidden");
  document.getElementById(select).style.maxHeight = document.getElementById(select).scrollHeight + "px";
});

var toggles = document.querySelectorAll(".kivi-toggle");
toggles.forEach(function(toggle) {
  toggle.addEventListener("click", function(e) {
    // e.target.classList.toggle("is-hidden");
    var select = e.target.dataset.target;
    // document.getElementById(select).classList.toggle("is-hidden");

    var panel = document.getElementById(select);
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
});

// Change back button url on Kivi single item page
var kiviBackBtn = document.querySelector('.kivi-back-button');
if (kiviBackBtn) {
  kiviBackBtn.setAttribute('href', "/kohteet/");
}